// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*.toolbar-container {
	position: relative;
	padding: 5px 0 0;
	background: #ADD137; 
	background: -moz-linear-gradient(top, #ADD137 0%, #799F3F 100%); 
	background: -webkit-linear-gradient(top, #ADD137 0%,#799F3F 100%); 
	background: linear-gradient(to bottom, #ADD137 0%,#799F3F 100%); 
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ADD137', endColorstr='#799F3F',GradientType=0 ); 
}*/

.toolbar-container {
	font-size: 11px;
	position: relative;
	display: table;
	width: 100%;
	height: 120px;
	/*	max-height: 106px;*/
	/*	background: url(../../images/toolbar-bg.jpg) repeat-x #eee;*/
	background: var(--main-secondary); /* Old browsers */
	background: -moz-linear-gradient(top,   var(--main-secondary)  0%,  var(--main-primary)  54%,  var(--main-primary)  54%, #eeeeee 55%, #eeeeee 100%); /* FF3.6-15 */
	background: -webkit-linear-gradient(top,  var(--main-secondary) 0%, var(--main-primary)  54%, var(--main-primary)  54%,#eeeeee 55%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to bottom,  var(--main-secondary) 0%, var(--main-primary)  54%, var(--main-primary)  54%,#eeeeee 55%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	
}

.tools {
	display: table-cell;
	width: 100%;
	margin: 0;
	padding: 0;
	vertical-align: top;
}

.toolbar-container .control-groupbar {
	position: relative;
	width: 100%;
	margin: 16px 0 0 0;
	background: #fcfcfc; /* Old browsers */
	background: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */
	background: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */

	/*border-top: 1px solid #d5d5d5;
	border-left: 1px solid #d5d5d5;
	border-right: 1px solid #d5d5d5;
	border-bottom: 1px solid #d5d5d5;*/

	border-radius: 4px 4px 0px 0px;
	-moz-border-radius: 4px 4px 0px 0px;
	-webkit-border-radius: 4px 4px 0px 0px;

	overflow: visible;

}


.control-groupbar > .nav-tabs > li:last-child > a {
	border-radius: 0px;
	-moz-border-radius: 0px;
	-webkit-border-radius: 0px;
}
/* Search bar */
.toolbar-container .control-groupbar .search {
	float: right;
	width: 24%;
	margin-right: 25px;
}

.toolbar-container .control-groupbar .search .search-box {
	width: 95%;
	margin: 4px 0 0;
}

.control-groupbar > .tab-content {
	border-radius: 0px;
	-moz-border-radius: 0px;
	-webkit-border-radius: 0px;
	border-left: 0px;
}

.control-groupbar > .nav-tabs > li:last-child > a, .control-groupbar > .nav-tabs > li:last-child.active a {
	border-radius: 0px !important;
	-moz-border-radius: 0px !important;
	-webkit-border-radius: 0px !important;
}

.control-groupbar > .nav-tabs > li.active > a, .control-groupbar > .nav-tabs > li.active > a:hover, .control-groupbar > .nav-tabs > li.active > a:focus {
	border-left: 0px;
}

.toolbox {
	position: relative;
	height: 100%;
	max-height: 85px;
	margin: 0;
	/*padding: 26px 0 27px;*/

	background: #fcfcfc; /* Old browsers */
	background: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */
	background: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */
	/*border-right: 1px solid #d5d5d5;
	border-bottom: 1px solid #d5d5d5;*/

	clear: both;

	/*box-shadow: 0px 2px 5px #bebebe;
	-moz-box-shadow: 0px 2px 5px #bebebe;
	-webkit-box-shadow: 0px 2px 5px #bebebe;*/
}

.carousel {
	/*margin-top: -15px;*/
	height: 58px;
}

.carousel-inner {
	width: 99%;
	height: 68px;
	margin: 0 auto;
	padding-left: 10px;
	padding-right: 10px;
}

.carousel-inner .active{
	margin-left: 10px!important;
}

.carousel .item {
	margin: 6px 0 0 2px;
}

.carousel ul li {
	list-style: none;
	float: left;
}

.carousel ul li ul {
	margin: 0;
	padding: 0;
} 

.carousel .item div {
	display: block;
    width: 100px;
	height: 55px;
}

.carousel .item div.asset {
	margin-left: 2px !important;
	margin-right: 2px !important;
}

@media screen and (max-width: 1200px) {
	.carousel .item div {
		margin-left: 1px !important;
	}
}

@media screen and (max-width: 768px) {
	.carousel .item div {
		display: inline-block;
	}
}

.carousel .item .thumb { 
	padding: 0;
	cursor: pointer;
	float: left;
	border: transparent; 
	color: #444;
	text-align: center;
}

.carousel .item .thumb:hover { 
	margin-top: 1px 0;
	padding-top: 1px 0;
	border: 1px solid #d5d5d5;
	border-radius: 4px;
	-webkit-border-radius: 4px;
	-moz-border-radius: 4px;
	box-shadow: 0px 1px 2px rgba(0,0,0,0.5);
	-webkit-box-shadow: 0px 1px 2px rgba(0,0,0,0.5);
	-moz-box-shadow: 0px 1px 2px rgba(0,0,0,0.5);
}

.carousel .item .common{ 
	margin-left:10px!important;
}

.carousel .item .thumb i { 
	font-size: 24px;
	font-size: 3rem; 
}

.carousel .item .thumb p { 
	font-size: 1rem;
	margin-top: -7px;
	width: 100%;
    margin-right: auto;
    margin-left: auto;
}

.carousel-control.right, .carousel-control.left {
	background: #fcfcfc; /* Old browsers */
	background: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */
	background: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */
	opacity: 1;
}

.carousel-control {
	top: 0px;
	width: 15px;
	height: 67px;
	color: #333;
	font-size: 2.4rem;
	display: flex;
    align-items: center;
    justify-content: center;
}

.carousel-control:hover {
	color: white;
	height: 68px;
	background: var(--main-primary) !important;
	background-image: -moz-linear-gradient(var(--gradient)) !important;
	background-image: -webkit-linear-gradient(var(--gradient)) !important;
	background-image: linear-gradient(var(--gradient-ToBottom)) !important;
}

.carousel-control i {
	font-size: 24px;
	font-size: 2.4rem;
	color: #333;
}

.carousel .ui-widget-header {
	font-weight: normal;
} 

#factories .fa {
	margin-top: 7px;
	margin-bottom: 0 !important;
	width: 100%;
	height: 25px;
	font-size: 2.5rem;
}

#toolbox-tabs li a {
	padding: 8px 10px;
}

#toolbox-tabs li{
	font-size: 10.5px!important;
}


.toolbar-mobile {
    height: 69px;
    bottom: 0px;
    position: relative !important;
    cursor: default;
	border-radius: 0 !important;
	min-width: 575px; 
	margin: 48px 0 0 0 !important; 
	border-right: 1px solid #d5d5d5;
    border-bottom: 1px solid #d5d5d5;
}

.ui-widget-header i{
	min-height: 25px;
}

.carousel .itemIcon{
	padding:0;
	margin:0;
	min-height:55px;
}

.carousel .itemName{
	padding:0;
	margin:0;
	margin-top:-13px;
}`, "",{"version":3,"sources":["webpack://./assets/style/partials/toolbar.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;;AAEF;CACC,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,+DAA+D;CAC/D,iCAAiC,EAAE,iBAAiB;CACpD,mJAAmJ,EAAE,aAAa;CAClK,gJAAgJ,EAAE,4BAA4B;CAC9K,8IAA8I,EAAE,qDAAqD;;AAEtM;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,SAAS;CACT,UAAU;CACV,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,kBAAkB;CAClB,mBAAmB,EAAE,iBAAiB;CACtC,gEAAgE,EAAE,aAAa;CAC/E,kEAAkE,EAAE,4BAA4B;CAChG,gEAAgE,EAAE,qDAAqD;CACvH,mHAAmH,EAAE,UAAU;;CAE/H;;;mCAGkC;;CAElC,8BAA8B;CAC9B,mCAAmC;CACnC,sCAAsC;;CAEtC,iBAAiB;;AAElB;;;AAGA;CACC,kBAAkB;CAClB,uBAAuB;CACvB,0BAA0B;AAC3B;AACA,eAAe;AACf;CACC,YAAY;CACZ,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC,UAAU;CACV,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,uBAAuB;CACvB,0BAA0B;CAC1B,gBAAgB;AACjB;;AAEA;CACC,6BAA6B;CAC7B,kCAAkC;CAClC,qCAAqC;AACtC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;CAChB,SAAS;CACT,wBAAwB;;CAExB,mBAAmB,EAAE,iBAAiB;CACtC,gEAAgE,EAAE,aAAa;CAC/E,kEAAkE,EAAE,4BAA4B;CAChG,gEAAgE,EAAE,qDAAqD;CACvH,mHAAmH,EAAE,UAAU;CAC/H;mCACkC;;CAElC,WAAW;;CAEX;;0CAEyC;AAC1C;;AAEA;CACC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,SAAS;CACT,UAAU;AACX;;AAEA;CACC,cAAc;IACX,YAAY;CACf,YAAY;AACb;;AAEA;CACC,2BAA2B;CAC3B,4BAA4B;AAC7B;;AAEA;CACC;EACC,2BAA2B;CAC5B;AACD;;AAEA;CACC;EACC,qBAAqB;CACtB;AACD;;AAEA;CACC,UAAU;CACV,eAAe;CACf,WAAW;CACX,mBAAmB;CACnB,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,yBAAyB;CACzB,kBAAkB;CAClB,0BAA0B;CAC1B,uBAAuB;CACvB,uCAAuC;CACvC,+CAA+C;CAC/C,4CAA4C;AAC7C;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;IACR,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;CACC,mBAAmB,EAAE,iBAAiB;CACtC,gEAAgE,EAAE,aAAa;CAC/E,kEAAkE,EAAE,4BAA4B;CAChG,gEAAgE,EAAE,qDAAqD;CACvH,mHAAmH,EAAE,UAAU;CAC/H,UAAU;AACX;;AAEA;CACC,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,WAAW;CACX,iBAAiB;CACjB,aAAa;IACV,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,0CAA0C;CAC1C,kEAAkE;CAClE,qEAAqE;CACrE,sEAAsE;AACvE;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,2BAA2B;CAC3B,WAAW;CACX,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,2BAA2B;AAC5B;;;AAGA;IACI,YAAY;IACZ,WAAW;IACX,6BAA6B;IAC7B,eAAe;CAClB,2BAA2B;CAC3B,gBAAgB;CAChB,6BAA6B;CAC7B,+BAA+B;IAC5B,gCAAgC;AACpC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,SAAS;CACT,QAAQ;CACR,eAAe;AAChB;;AAEA;CACC,SAAS;CACT,QAAQ;CACR,gBAAgB;AACjB","sourcesContent":["/*.toolbar-container {\r\n\tposition: relative;\r\n\tpadding: 5px 0 0;\r\n\tbackground: #ADD137; \r\n\tbackground: -moz-linear-gradient(top, #ADD137 0%, #799F3F 100%); \r\n\tbackground: -webkit-linear-gradient(top, #ADD137 0%,#799F3F 100%); \r\n\tbackground: linear-gradient(to bottom, #ADD137 0%,#799F3F 100%); \r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ADD137', endColorstr='#799F3F',GradientType=0 ); \r\n}*/\r\n\r\n.toolbar-container {\r\n\tfont-size: 11px;\r\n\tposition: relative;\r\n\tdisplay: table;\r\n\twidth: 100%;\r\n\theight: 120px;\r\n\t/*\tmax-height: 106px;*/\r\n\t/*\tbackground: url(../../images/toolbar-bg.jpg) repeat-x #eee;*/\r\n\tbackground: var(--main-secondary); /* Old browsers */\r\n\tbackground: -moz-linear-gradient(top,   var(--main-secondary)  0%,  var(--main-primary)  54%,  var(--main-primary)  54%, #eeeeee 55%, #eeeeee 100%); /* FF3.6-15 */\r\n\tbackground: -webkit-linear-gradient(top,  var(--main-secondary) 0%, var(--main-primary)  54%, var(--main-primary)  54%,#eeeeee 55%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */\r\n\tbackground: linear-gradient(to bottom,  var(--main-secondary) 0%, var(--main-primary)  54%, var(--main-primary)  54%,#eeeeee 55%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\r\n\t\r\n}\r\n\r\n.tools {\r\n\tdisplay: table-cell;\r\n\twidth: 100%;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tvertical-align: top;\r\n}\r\n\r\n.toolbar-container .control-groupbar {\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\tmargin: 16px 0 0 0;\r\n\tbackground: #fcfcfc; /* Old browsers */\r\n\tbackground: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */\r\n\tbackground: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */\r\n\tbackground: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */\r\n\r\n\t/*border-top: 1px solid #d5d5d5;\r\n\tborder-left: 1px solid #d5d5d5;\r\n\tborder-right: 1px solid #d5d5d5;\r\n\tborder-bottom: 1px solid #d5d5d5;*/\r\n\r\n\tborder-radius: 4px 4px 0px 0px;\r\n\t-moz-border-radius: 4px 4px 0px 0px;\r\n\t-webkit-border-radius: 4px 4px 0px 0px;\r\n\r\n\toverflow: visible;\r\n\r\n}\r\n\r\n\r\n.control-groupbar > .nav-tabs > li:last-child > a {\r\n\tborder-radius: 0px;\r\n\t-moz-border-radius: 0px;\r\n\t-webkit-border-radius: 0px;\r\n}\r\n/* Search bar */\r\n.toolbar-container .control-groupbar .search {\r\n\tfloat: right;\r\n\twidth: 24%;\r\n\tmargin-right: 25px;\r\n}\r\n\r\n.toolbar-container .control-groupbar .search .search-box {\r\n\twidth: 95%;\r\n\tmargin: 4px 0 0;\r\n}\r\n\r\n.control-groupbar > .tab-content {\r\n\tborder-radius: 0px;\r\n\t-moz-border-radius: 0px;\r\n\t-webkit-border-radius: 0px;\r\n\tborder-left: 0px;\r\n}\r\n\r\n.control-groupbar > .nav-tabs > li:last-child > a, .control-groupbar > .nav-tabs > li:last-child.active a {\r\n\tborder-radius: 0px !important;\r\n\t-moz-border-radius: 0px !important;\r\n\t-webkit-border-radius: 0px !important;\r\n}\r\n\r\n.control-groupbar > .nav-tabs > li.active > a, .control-groupbar > .nav-tabs > li.active > a:hover, .control-groupbar > .nav-tabs > li.active > a:focus {\r\n\tborder-left: 0px;\r\n}\r\n\r\n.toolbox {\r\n\tposition: relative;\r\n\theight: 100%;\r\n\tmax-height: 85px;\r\n\tmargin: 0;\r\n\t/*padding: 26px 0 27px;*/\r\n\r\n\tbackground: #fcfcfc; /* Old browsers */\r\n\tbackground: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */\r\n\tbackground: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */\r\n\tbackground: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */\r\n\t/*border-right: 1px solid #d5d5d5;\r\n\tborder-bottom: 1px solid #d5d5d5;*/\r\n\r\n\tclear: both;\r\n\r\n\t/*box-shadow: 0px 2px 5px #bebebe;\r\n\t-moz-box-shadow: 0px 2px 5px #bebebe;\r\n\t-webkit-box-shadow: 0px 2px 5px #bebebe;*/\r\n}\r\n\r\n.carousel {\r\n\t/*margin-top: -15px;*/\r\n\theight: 58px;\r\n}\r\n\r\n.carousel-inner {\r\n\twidth: 99%;\r\n\theight: 68px;\r\n\tmargin: 0 auto;\r\n\tpadding-left: 10px;\r\n\tpadding-right: 10px;\r\n}\r\n\r\n.carousel-inner .active{\r\n\tmargin-left: 10px!important;\r\n}\r\n\r\n.carousel .item {\r\n\tmargin: 6px 0 0 2px;\r\n}\r\n\r\n.carousel ul li {\r\n\tlist-style: none;\r\n\tfloat: left;\r\n}\r\n\r\n.carousel ul li ul {\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n} \r\n\r\n.carousel .item div {\r\n\tdisplay: block;\r\n    width: 100px;\r\n\theight: 55px;\r\n}\r\n\r\n.carousel .item div.asset {\r\n\tmargin-left: 2px !important;\r\n\tmargin-right: 2px !important;\r\n}\r\n\r\n@media screen and (max-width: 1200px) {\r\n\t.carousel .item div {\r\n\t\tmargin-left: 1px !important;\r\n\t}\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n\t.carousel .item div {\r\n\t\tdisplay: inline-block;\r\n\t}\r\n}\r\n\r\n.carousel .item .thumb { \r\n\tpadding: 0;\r\n\tcursor: pointer;\r\n\tfloat: left;\r\n\tborder: transparent; \r\n\tcolor: #444;\r\n\ttext-align: center;\r\n}\r\n\r\n.carousel .item .thumb:hover { \r\n\tmargin-top: 1px 0;\r\n\tpadding-top: 1px 0;\r\n\tborder: 1px solid #d5d5d5;\r\n\tborder-radius: 4px;\r\n\t-webkit-border-radius: 4px;\r\n\t-moz-border-radius: 4px;\r\n\tbox-shadow: 0px 1px 2px rgba(0,0,0,0.5);\r\n\t-webkit-box-shadow: 0px 1px 2px rgba(0,0,0,0.5);\r\n\t-moz-box-shadow: 0px 1px 2px rgba(0,0,0,0.5);\r\n}\r\n\r\n.carousel .item .common{ \r\n\tmargin-left:10px!important;\r\n}\r\n\r\n.carousel .item .thumb i { \r\n\tfont-size: 24px;\r\n\tfont-size: 3rem; \r\n}\r\n\r\n.carousel .item .thumb p { \r\n\tfont-size: 1rem;\r\n\tmargin-top: -7px;\r\n\twidth: 100%;\r\n    margin-right: auto;\r\n    margin-left: auto;\r\n}\r\n\r\n.carousel-control.right, .carousel-control.left {\r\n\tbackground: #fcfcfc; /* Old browsers */\r\n\tbackground: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */\r\n\tbackground: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */\r\n\tbackground: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */\r\n\topacity: 1;\r\n}\r\n\r\n.carousel-control {\r\n\ttop: 0px;\r\n\twidth: 15px;\r\n\theight: 67px;\r\n\tcolor: #333;\r\n\tfont-size: 2.4rem;\r\n\tdisplay: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.carousel-control:hover {\r\n\tcolor: white;\r\n\theight: 68px;\r\n\tbackground: var(--main-primary) !important;\r\n\tbackground-image: -moz-linear-gradient(var(--gradient)) !important;\r\n\tbackground-image: -webkit-linear-gradient(var(--gradient)) !important;\r\n\tbackground-image: linear-gradient(var(--gradient-ToBottom)) !important;\r\n}\r\n\r\n.carousel-control i {\r\n\tfont-size: 24px;\r\n\tfont-size: 2.4rem;\r\n\tcolor: #333;\r\n}\r\n\r\n.carousel .ui-widget-header {\r\n\tfont-weight: normal;\r\n} \r\n\r\n#factories .fa {\r\n\tmargin-top: 7px;\r\n\tmargin-bottom: 0 !important;\r\n\twidth: 100%;\r\n\theight: 25px;\r\n\tfont-size: 2.5rem;\r\n}\r\n\r\n#toolbox-tabs li a {\r\n\tpadding: 8px 10px;\r\n}\r\n\r\n#toolbox-tabs li{\r\n\tfont-size: 10.5px!important;\r\n}\r\n\r\n\r\n.toolbar-mobile {\r\n    height: 69px;\r\n    bottom: 0px;\r\n    position: relative !important;\r\n    cursor: default;\r\n\tborder-radius: 0 !important;\r\n\tmin-width: 575px; \r\n\tmargin: 48px 0 0 0 !important; \r\n\tborder-right: 1px solid #d5d5d5;\r\n    border-bottom: 1px solid #d5d5d5;\r\n}\r\n\r\n.ui-widget-header i{\r\n\tmin-height: 25px;\r\n}\r\n\r\n.carousel .itemIcon{\r\n\tpadding:0;\r\n\tmargin:0;\r\n\tmin-height:55px;\r\n}\r\n\r\n.carousel .itemName{\r\n\tpadding:0;\r\n\tmargin:0;\r\n\tmargin-top:-13px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
